import { render, staticRenderFns } from "./ReceiveBenefits.vue?vue&type=template&id=95bfda64&scoped=true&"
import script from "./ReceiveBenefits.vue?vue&type=script&lang=js&"
export * from "./ReceiveBenefits.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveBenefits.vue?vue&type=style&index=0&id=95bfda64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bfda64",
  null
  
)

export default component.exports